import { useMemo } from "react";

// Styles
import NOPATAssumptionsViewContainer from "./NOPATAssumptionsView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";
import { useLocation } from "react-router-dom";
import { useBQMQ } from "context/BQMQ.context";

interface NOPATAssumptionsViewProps {}

const NOPATAssumptionsView = ({}: NOPATAssumptionsViewProps) => {
    const location = useLocation();
    const { companies } = useBQMQ();

    const companyId = useMemo(() => {
        return new URLSearchParams(location.search).get("company_id");
    }, [location.search]);

    const company = useMemo(() => {
        if (!companyId) return null;
        return (
            companies.find(
                (c: BQMQDropdownCompany) => String(c.value) === companyId
            ) ?? null
        );
    }, [companyId, companies]);

    const redshiftId = company?.redshift_company_id ?? null;

    const filterString =
        redshiftId != null
            ? `CoreSnapshot/company_id eq ${redshiftId}`
            : undefined;

    return (
        <NOPATAssumptionsViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="f04bcba8-32ab-444c-af4d-2680e6a6bf4a"
                    workspaceId="b14429d8-b8bf-4792-a9bd-c89b8f4ba4e2"
                    filterString={filterString}
                />
            </div>
        </NOPATAssumptionsViewContainer>
    );
};
export default NOPATAssumptionsView;
